export default "__VITE_ASSET__BAWTkOxg__"